exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".no-head__28tWF thead {\n  display: none;\n}\n", ""]);

// Exports
exports.locals = {
	"no-head": "no-head__28tWF"
};